// extracted by mini-css-extract-plugin
export default {"container":"card_container__OXCMv","text":"card_text__LuVjd","days":"card_days__UgW0I"};